import { format } from 'date-fns';
import React from 'react';

const ServiceModal = ({ treatment, setTreatment, selectedDate }) => {
    const { name, slots } = treatment;
    const date = format(selectedDate, 'PPPP')
    const handelService = event => {
        event.preventDefault();
        const form = event.target; 
        const name = form.name.value;
        const email = form.email.value;
        const slot = form.slot.value;
        const phone = form.phone.value;
        const service = {
            appointmentDate: date,
            treatment: name,
            patient: name,
            slot,
            email,
            phone
        }
        console.log(service);

        setTreatment(null)
    }
    return (
        <>
            <input type="checkbox" id="service-modal" className="modal-toggle" />
            <div className="modal">
                <div className="modal-box relative">
                    <label htmlFor="service-modal" className="btn btn-sm btn-circle absolute right-2 top-2">✕</label>
                    <h3 className="text-lg font-bold">{name}</h3>
                    <form onSubmit={handelService} className='grid grid-cols-1 gap-3 mt-12'>
                        <input type="text" disabled value={date} className="input w-full input-bordered " />
                        <select name='slot' className="select select-bordered w-full ">
                            
                            {
                                slots.map((slot, i) => <option key={i} value={slot}>{ slot}</option>)
                            }
                        </select>
                        <input name='name' type="text" placeholder="Your Name" className="input w-full input-bordered " />
                        <input name='email' type="email" placeholder="Email Address" className="input w-full input-bordered " />
                        <input name='phone' type="text" placeholder="Phone Number" className="input w-full input-bordered " />
                        <br />
                        <input type="submit" className='btn btn-primary w-full input-bordered ' value='Submit' />
                    </form>
                </div>
            </div>
        </>
    );
};

export default ServiceModal;